<template lang="pug">
  #entities.center-panel.md-scrollbar.md-theme-default
    md-content.md-layout-row.md-gutter.md-elevation-1(md-theme="white")
      module-menu
      .md-flex(md-theme="white")
        md-table(md-theme="white")
          md-table-row(v-for="entity in entities" v-bind:key="entity.id" v-bind:class="($route.params.entity_code && $route.params.entity_code == entity.code) ? 'entity-row hovered' : 'entity-row'")
            md-table-cell.load
              router-link.small.md-primary(v-bind:to="{ name: 'Entity', params: {code: $route.params.code, entity_code: entity.code}, query: $route.query }")
                span.md-layout-row.md-gutter
                  span.md-flex.name {{entity.name + ' (' + entity.code + ')'}}
</template>

<script>
  import ModuleMenu from './menu.vue';
  import ModuleProperty from '../../../components/ModulePtoperty';

  export default {
    data() {
      return {
      }
    },
    watch: {

    },
    components: {
      ModuleMenu,
      ModuleProperty
    },
    computed: {
      entities() {
        return this.$store.state.module.entities;
      }
    },
    created() {
      this.getModuleEntities();
    },
    methods: {
      getModuleEntities() {
        this.$store.dispatch('module/getModuleEntities');
      }
    }
  }
</script>
<style scoped lang="sass">
  .entity-row.hovered
    .md-table-cell
      background-color: var(--md-theme-default-highlight-on-background, rgba(0, 0, 0, 0.08));
</style>



// WEBPACK FOOTER //
// Entities.vue?c247c6e6